import { useEffect, useState, Fragment } from "react";
import DashboardLayout from "../../Layouts/Layoutcontainers";
import EnhancedTable from "../../components/BTTable";
import BTBox from "../../components/BTBox";
import BTButton from "../../components/BTButton";
import BTInput from "../../components/BTInput";
import Addbill from "./Addbill.js";
import Swal from "sweetalert2";
import authService from "../../services/auth-service.js";
import {
  IconButton,
  Card,
  TextField,
  Autocomplete,
  FormControlLabel,
  Switch,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import {
  PictureAsPdf,
  Error,
  TrackChanges,
  Edit,
  Delete,
  Notifications,
} from "@mui/icons-material";
import InvoicePDF from "./reports";
import { pdf } from "@react-pdf/renderer";
import { useLoading, useNotification } from "../../context";
import {
  get_cnv_rates,
  get_parties,
  get_sizes,
} from "../../store/functions.js";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import BTDialogBox from "../../components/BTDialgBox/index.js";
import BTBadge from "../../components/BTBadge/index.js";
import { stone_status } from "../../dropdownData/index.js";
import { fetchData } from "../../utils/fetchData.js";
import { get, batchUpdate } from "../../store/labSlice.js";
const default_search = {
  type: 1,
  p_id: null,
  from_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
  to_date: moment().add(1).format("YYYY-MM-DD"),
  rowsPerPage: 50,
  page: 1,
  searchText: null,
  last_id: 0,
  p_bill_id: null,
};
const CardHeader = ({
  search,
  setSearch,
  parties,
  tableType,
  setTableType,
  clearState,
}) => {
  const [localDates, setLocalDates] = useState({
    from_date: search?.from_date || "",
    to_date: search?.to_date || "",
  });
  const handleDateChange = (field, value) => {
    const newDates = { ...localDates, [field]: value };
    setLocalDates(newDates);
    const timer = setTimeout(() => {
      clearState();
      setSearch({
        ...search,
        from_date: newDates.from_date,
        to_date: newDates.to_date,
        page: 1,
      });
    }, 500);

    return () => clearTimeout(timer);
  };

  return (
    <Card sx={{ mb: 1 }}>
      <BTBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}
      >
        <BTBox
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={tableType}
                onChange={() => {
                  clearState();
                  setTableType(!tableType);
                  setSearch({
                    ...default_search,
                    type: tableType ? 1 : 2,
                  });
                }}
                size="small"
                color="secondary"
              />
            }
            label={"All records"}
            labelPlacement="end"
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          />

          <BTInput
            size="small"
            type="date"
            label="From Date"
            value={localDates.from_date}
            onChange={(e) => handleDateChange("from_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />

          <BTInput
            size="small"
            type="date"
            label="To Date"
            value={localDates.to_date}
            onChange={(e) => handleDateChange("to_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />
          <Autocomplete
            options={parties || []}
            getOptionLabel={(option) =>
              `${option.p_code} : ${option.p_name}` || ""
            }
            renderOption={(props, option) => (
              <li {...props}>{`${option.p_code} : ${option.p_name}`}</li>
            )}
            onChange={(event, value) => {
              clearState();
              setSearch({ ...search, p_id: value?.p_id, page: 1 });
            }}
            sx={{ width: "100%" }}
            value={parties?.find(({ p_id }) => p_id === search?.p_id) || null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Party"
                size="small"
                variant="standard"
                sx={{ width: { xs: "100%", sm: "200px" } }}
              />
            )}
          />
        </BTBox>
      </BTBox>
    </Card>
  );
};

const ExpandComponent = ({ row, expandColumns, subRefresh, bill }) => {
  const [subRecords, setSubRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState({
    type: 2,
    p_id: null,
    from_date: null,
    to_date: null,
    rowsPerPage: 50000000000,
    page: 1,
    searchText: null,
    last_id: 0,
    p_bill_id: row?.bill_id,
  });

  useEffect(() => {
    const localSubs = bill?.filter(
      ({ p_bill_id, bill_type }) =>
        bill_type === 2 && p_bill_id === row?.bill_id
    );
    if (localSubs > 0) {
      setSubRecords(localSubs);
    } else {
      fetchSubs();
    }
  }, [row, bill, subRefresh]);

  const fetchSubs = async () => {
    try {
      const response = await fetchData({
        api: "get_bills",
        name: "bill",
        key: "bill_id",
        searchParams: search,
        filterCallback: null,
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        hold: false,
      });
      if (response?.status) {
        setSubRecords(response?.data);
      }
    } finally {
    }
  };
  return (
    <EnhancedTable
      loading={loading}
      rows={subRecords}
      columns={expandColumns}
      tableHeader={true}
      title="Billings"
    />
  );
};

const Submissions = ({
  showSubmissions,
  setShowSubmissions,
  parties,
  sizes,
}) => {
  const [loading, setLoading] = useState(false);
  const closeModal = () => {
    setShowSubmissions(null);
  };
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      value: (row) => row?.stn_id,
      width: "50px",
      numeric: false,
      sortable: true,
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_cus_ref_no",
      name: "Customer Ref No",
      selector: (row) => row?.stn_cus_ref_no,
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_pcs",
      name: "Pcs",
      selector: (row) => row?.stn_pcs,
      width: "50px",
      sortable: true,
    },
    {
      id: "p_id",
      name: "Party",
      selector: (row) =>
        parties?.find(({ p_id }) => p_id === row?.p_id)?.p_name,
      numeric: false,
      sortable: true,
      width: "200px",
    },
    {
      id: "p_code",
      name: "Party code",
      selector: (row) =>
        parties?.find(({ p_id }) => p_id === row?.p_id)?.p_code,
      sortable: true,
      width: "100px",
    },
    {
      id: "stn_cts",
      name: "Weight",
      selector: (row) => Number(row?.stn_cts)?.toFixed(2),
      width: "50px",
      sortable: true,
    },
    {
      id: "lab_cts",
      name: "Lab Weight",
      selector: (row) => row?.lab_cts,
      width: "50px",
      sortable: true,
    },
    {
      id: "size_id",
      name: "Size",
      selector: (row) => {
        const size = sizes?.find(({ size_id }) => size_id === row?.size_id);
        return `${size?.size_from} - ${size?.size_to}`;
      },
    },
    {
      id: "services",
      name: "Services",
      selector: (row) => {
        const joinedString = row?.stn_services
          ?.map((item) => item.ser_name)
          .join(", ");
        return joinedString;
      },
      width: "150px",
    },
    {
      id: "aditional_services",
      name: "Aditional Services",
      selector: (row) => {
        let services = [];
        if (row?.stn_without_plot) {
          services?.push("Without Plotting");
        }
        if (row?.stn_tatkal) {
          services?.push("Tatkal");
        }
        if (row?.stn_color) {
          services?.push("Color");
        }
        return services?.join(",");
      },
      width: "150px",
    },
    {
      id: "stn_date",
      name: "Date",
      selector: (row) =>
        moment(row?.stn_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY"),
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_status",
      name: "Status",
      value: (row) => {
        const name = stone_status?.find(
          ({ value }) => value === row?.stn_status
        )?.label;
        return name;
      },
      selector: (row) => {
        const name = stone_status?.find(
          ({ value }) => value === row?.stn_status
        )?.label;
        return (
          <BTBadge badgeContent={name} size="xs" container color="success" />
        );
      },
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_desc",
      name: "Description",
      selector: (row) => row?.stn_desc,
      width: "100px",
    },
  ];

  return (
    <BTDialogBox
      open={Boolean(showSubmissions)}
      fullWidth
      maxWidth="xl"
      maxHeight="500px"
      minHeight="500px"
      // onSubmit={submitBill}
      close={closeModal}
      title={"Submission"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: closeModal,
        },
      ]}
    >
      <EnhancedTable title="#" columns={columns} rows={showSubmissions} />
    </BTDialogBox>
  );
};
const Bill = () => {
  const userdata = secureLocalStorage.getItem("userdata");
  const gst_number = userdata?.u_profile?.cmp_gst?.slice(0, 2);
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const parties = useSelector((state) => state?.lab?.parties);
  const sizes = useSelector((state) => state?.lab?.sizes);
  const conversionRate = useSelector((state) => state?.lab?.conversionRate);
  const bill = useSelector((state) => state?.lab?.bill);
  const [open, setOpen] = useState(null);
  const [subRefresh, setSubRefresh] = useState(false);
  const [showSubmissions, setShowSubmissions] = useState(null);
  const [search, setSearch] = useState(default_search);
  const [tableType, setTableType] = useState(false);
  const [loading, setLoading] = useState(false);
  const todayDate = moment().format("YYYY-MM-DD");
  const todayRate =
    conversionRate?.data?.find(
      (rate) => moment(rate.cnv_date).format("YYYY-MM-DD") === todayDate
    )?.cnv_rate || 0;
  useEffect(() => {
    !parties?.is_fetch && get_parties();
    !sizes?.is_fetch && get_sizes();
    !conversionRate?.is_fetch && get_cnv_rates();
  }, []);

  let pageIndex = bill?.pages?.findIndex((p) => p.page === search.page);
  const startIndex = pageIndex !== -1 ? pageIndex * search.rowsPerPage : 0;
  const endIndex = startIndex + search.rowsPerPage;
  useEffect(() => {
    fetchBiils();
  }, [search]);
  const handleSearch = (data, searchData) => {
    const filterBySearch = data?.filter((item) => {
      const searchText = searchData?.searchText?.toLowerCase().trim() || "";
      const matchFilters =
        item?.bill_type === searchData?.type &&
        (searchData?.p_id ? item?.p_id === searchData?.p_id : true) &&
        moment(item.bill_date, "YYYY-MM-DD").isBetween(
          moment(searchData?.from_date, "YYYY-MM-DD").startOf("day"),
          moment(searchData?.to_date, "YYYY-MM-DD").endOf("day"),
          null,
          "[]"
        );
      return matchFilters;
    });
    const paginateData = filterBySearch?.slice(startIndex, endIndex);
    return paginateData;
  };
  const fetchBiils = async () => {
    await fetchData({
      api: "get_bills",
      name: "bill",
      key: "bill_id",
      searchParams: search,
      filterCallback: handleSearch,
      showLoading: () => setLoading(true),
      hideLoading: () => setLoading(false),
      hold: true,
    });
  };
  const clearState = () => {
    dispatch(
      get({
        name: "bill",
        data: [],
        pages: [],
        total: 0,
        fetch: false,
      })
    );
  };

  // functions
  const handleDownloadPDF = async (row) => {
    const { bill_id } = row || {};
    const response = await fetchData({
      api: "get_bills",
      name: "bill",
      key: "bill_id",
      searchParams: {
        ...default_search,
        rowsPerPage: 5000000,
        page: 1,
        p_bill_id: bill_id,
      },
      filterCallback: null,
      showLoading,
      hideLoading,
      hold: false,
    });
    if (!response?.status) {
      addNotification({
        message:
          response?.message ||
          "Failed to connect to server. Please try again later.",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } else {
      let billsData = {
        ...row,
        sub_billing_lines: response?.data,
      };
      const blob = await pdf(
        <InvoicePDF data={billsData} sizes={sizes} loginuser={userdata} />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const newTab = window.open(url, "_blank");
      newTab.document.close();
      newTab.onbeforeunload = () => {
        URL.revokeObjectURL(url);
      };
    }
  };
  const handleDownloadJson = async (e, data) => {
    const asNumber = (v, fallback = null) => {
      if (v === null || v === undefined || v === "") return fallback;
      const n = Number(v);
      return Number.isFinite(n) ? n : fallback;
    };

    // helper: round to 2 decimals and return Number (not string)
    const round2 = (n) => {
      return asNumber(Number(Math.round((n + Number.EPSILON) * 100) / 100), 0);
    };

    // derive state code from GSTIN (first two chars) if available
    const getStateCodeFromGstin = (gstin) => {
      if (!gstin || typeof gstin !== "string") return null;
      const sc = gstin.substring(0, 2);
      return /^\d{2}$/.test(sc) ? sc : null;
    };

    const template = {
      Version: "1.1",
      TranDtls: {
        TaxSch: "GST",
        SupTyp: "B2B",
        IgstOnIntra: "N",
        RegRev: null,
        EcmGstin: null,
      },
      DocDtls: {
        Typ: "INV",
        No: "I1476/25-26",
        Dt: "25/07/2025",
      },
      SellerDtls: {
        Gstin: userdata?.u_profile?.cmp_gst || null,
        LglNm: userdata?.u_profile?.cmp_name || null,
        TrdNm: null,
        Addr1: userdata?.u_profile?.cmp_addr_line1 || null,
        Addr2: userdata?.u_profile?.cmp_addr_line2 || null,
        Loc: userdata?.u_profile?.cmp_city || null,
        Pin: asNumber(userdata?.u_profile?.cmp_pincode, null),
        Stcd: getStateCodeFromGstin(userdata?.u_profile?.cmp_gst),
        Ph: userdata?.u_profile?.cmp_ph || null,
        Em: userdata?.u_profile?.cmp_email || null,
      },
      BuyerDtls: {
        Gstin: null,
        LglNm: null,
        TrdNm: null,
        Pos: "24",
        Addr1: null,
        Addr2: null,
        Loc: null,
        Pin: null,
        Stcd: null,
        Ph: null,
        Em: null,
      },
      DispDtls: null,
      ValDtls: {
        AssVal: 0,
        IgstVal: 0,
        CgstVal: 0,
        SgstVal: 0,
        CesVal: 0,
        StCesVal: 0,
        Discount: 0,
        OthChrg: 0,
        RndOffAmt: 0,
        TotInvVal: 0,
      },
      ItemList: [
        {
          SlNo: "1",
          PrdDesc: "Certificate Charges",
          IsServc: "Y",
          HsnCd: "998346",
          Qty: 1,
          Unit: "PCS",
          UnitPrice: 0,
          TotAmt: 0,
          Discount: 0,
          PreTaxVal: 0,
          AssAmt: 0,
          GstRt: 18,
          IgstAmt: 0,
          CgstAmt: 0,
          SgstAmt: 0,
          CesRt: 0,
          CesAmt: 0,
          CesNonAdvlAmt: 0,
          StateCesRt: 0,
          StateCesAmt: 0,
          StateCesNonAdvlAmt: 0,
          OthChrg: 0,
          TotItemVal: 0,
        },
      ],
    };
    const jsonformateData = data?.map((item, index) => {
     

      const billTotal = asNumber(item?.bill_total, 0);

      const gstRate = asNumber(
        item?.bill_gst_rate ?? userdata?.u_profile?.cmp_gst_rate,
        asNumber(userdata?.u_profile?.cmp_gst_rate, 18)
      );

      // seller and buyer state codes
      const sellerState =
        template.SellerDtls.Stcd ||
        getStateCodeFromGstin(template.SellerDtls.Gstin);
      const buyerState =
        item?.p_org_state_code ||
        getStateCodeFromGstin(item?.p_org_gst) ||
        null;

      // tax calc (rounded to 2 decimals)
      const rawTax = (billTotal * Number(gstRate)) / 100;
      const tax = round2(rawTax);

      let igst = 0,
        cgst = 0,
        sgst = 0;
      if (sellerState && buyerState && sellerState === buyerState) {
        // intra-state: split into CGST & SGST equally
        cgst = round2(tax / 2);
        sgst = round2(tax / 2);
        // adjust for rounding differences to make sum exactly = tax
        // const sumCgSg = round2(cgst + sgst);
        // if (sumCgSg !== tax) {
        //   // adjust cgst to absorb difference
        //   cgst = round2(cgst + (tax - sumCgSg));
        // }
      } else {
        // inter-state: IGST only
        igst = tax;
      }

      const totInvVal = Math.round(billTotal + tax);
      const unitPrice = round2(billTotal);
      const totItemVal = totInvVal; // single-line invoice assumption

      // phone handling (avoid "null/null" or "undefined/..." strings)
      const phone1 = item?.p_org_mo_no_1 || null;
      const phone2 = item?.p_org_mo_no_2 || null;
      let phoneConcat = null;
      if (phone1 && phone2) phoneConcat = `${phone1}/${phone2}`;
      else if (phone1) phoneConcat = phone1;
      else if (phone2) phoneConcat = phone2;
      else phoneConcat = null;

      // pin handling: keep number if available else null
      const buyerPin = asNumber(item?.p_org_pincode, null);

      return {
        ...template,
        DocDtls: {
          ...template.DocDtls,
          No: item?.bill_invoice || template.DocDtls.No,
          Dt: item?.bill_date
            ? moment(item?.bill_date).format("DD/MM/YYYY")
            : template.DocDtls.Dt,
        },
        SellerDtls: {
          ...template.SellerDtls,
          // keep existing seller info from userdata (already set in template)
          // ensure Pin is numeric or null
          Pin: asNumber(
            userdata?.u_profile?.cmp_pincode,
            template.SellerDtls.Pin
          ),
        },
        BuyerDtls: {
          ...template.BuyerDtls,
          Gstin: item?.p_org_gst || null,
          LglNm: item?.p_org_name || null,
          Addr1: item?.p_org_address_line1 || null,
          Addr2: item?.p_org_address_line2 || null,
          Pin: buyerPin,
          Ph: phoneConcat,
          Em: item?.p_org_email || null,
          Loc: item?.p_address || null,
          Stcd: buyerState,
          Pos: buyerState || template.BuyerDtls.Pos,
        },
        ValDtls: {
          ...template.ValDtls,
          AssVal: round2(billTotal),
          IgstVal: round2(igst),
          CgstVal: round2(cgst),
          SgstVal: round2(sgst),
          TotInvVal: totInvVal,
        },
        ItemList: [
          {
            ...template.ItemList[0],
            SlNo: String(index + 1),
            UnitPrice: unitPrice,
            TotAmt: round2(billTotal),
            AssAmt: round2(billTotal),
            GstRt: gstRate,
            IgstAmt: round2(igst),
            CgstAmt: round2(cgst),
            SgstAmt: round2(sgst),
            TotItemVal: totItemVal,
          },
        ],
      };
    });

    const jsonString = JSON.stringify(jsonformateData, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "example.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const deleteBill = async (row) => {
    const { bill_id } = row || {};
    const response = await fetchData({
      api: "get_bills",
      name: "bill",
      key: "bill_id",
      searchParams: {
        ...default_search,
        rowsPerPage: 5000000,
        page: 1,
        p_bill_id: bill_id,
      },
      filterCallback: null,
      showLoading,
      hideLoading,
      hold: false,
    });
    if (!response?.status) {
      addNotification({
        message:
          response?.message ||
          "Failed to connect to server. Please try again later.",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } else {
      let billsData = {
        ...row,
        sub_billing_lines: response?.data,
      };

      Swal.fire({
        title: "Are You Sure?",
        icon: "error",
        showCancelButton: true,
        button: {
          text: "Confirm!",
          closeModal: false,
          color: "info",
        },
        zIndex: "100000000",
      }).then(async (res) => {
        if (res?.isConfirmed) {
          const myData = {
            attributes: billsData,
          };
          try {
            let response = await authService?.delete_bill(myData);
            if (response?.status) {
              const { returns, submits } = response?.data;
              dispatch(
                batchUpdate({
                  name: "submission",
                  key: "stn_id",
                  insert: [],
                  updateItems: submits,
                  removeItems: [],
                })
              );
              dispatch(
                batchUpdate({
                  name: "return",
                  key: "ret_id",
                  insert: [],
                  updateItems: returns,
                  removeItems: [],
                })
              );
              dispatch(
                batchUpdate({
                  name: "bill",
                  key: "bill_id",
                  insert: [],
                  updateItems: [],
                  removeItems: [row, billsData?.sub_billing_lines],
                })
              );
            }
            // if (response?.status === 1) {
            //   const { returns, submits } = response?.data;
            //   const { sub_billing_lines, ...record } = data;
            //   manage_store_data({
            //     name: "submissions",
            //     key: "stn_id",
            //     data: submits,
            //     type: "update",
            //     total: null,
            //   });
            //   manage_store_data({
            //     name: "labouts",
            //     key: "ret_id",
            //     data: returns,
            //     type: "update",
            //     total: null,
            //   });
            //   manage_store_data({
            //     name: "bills",
            //     key: "bill_id",
            //     data: [record, ...sub_billing_lines],
            //     type: "remove",
            //   });
            //   setRefresh(!refresh);
            //   addNotification({
            //     icon: <Notifications color="white" />,
            //     title: "Successfully",
            //     message: response?.message,
            //     color: "success",
            //   });
            // }
          } catch (res) {
            addNotification({
              title: "#Error",
              message: res?.message || "Something went to wrong",
              color: "error",
              icon: <Error color="white" size="small" />,
            });
          }
        }
      });
    }
  };

  const openSubmissions = async (bill_id) => {
    const params = {
      type: 2,
      p_id: null,
      from_date: null,
      to_date: null,
      rowsPerPage: 100000000,
      page: 1,
      searchText: null,
      last_id: 0,
      status: null,
      p_stn_id: null,
      stn_bill_number: bill_id,
    };
    try {
      const response = await fetchData({
        api: "get_submissions",
        name: "submission",
        key: "stn_id",
        searchParams: params,
        filterCallback: null,
        showLoading,
        hideLoading,
        hold: false,
      });
      if (!response?.status) {
        addNotification({
          message:
            response?.message ||
            "Failed to connect to server. Please try again later.",
          type: "error",
          color: "error",
          icon: <Error fontSize="small" color="white" />,
        });
      } else {
        setShowSubmissions(response?.data);
      }
    } catch (error) {}
  };
  const handleEdit = async (row) => {
    const { bill_id } = row || {};
    const response = await fetchData({
      api: "get_bills",
      name: "bill",
      key: "bill_id",
      searchParams: {
        ...default_search,
        rowsPerPage: 5000000,
        page: 1,
        p_bill_id: bill_id,
      },
      filterCallback: null,
      showLoading,
      hideLoading,
      hold: false,
    });
    if (!response?.status) {
      addNotification({
        message:
          response?.message ||
          "Failed to connect to server. Please try again later.",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } else {
      setOpen({
        billsData: {
          ...row,
          sub_billing_lines: response?.data,
        },
      });
    }
  };
  const expandColumns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "bill_invoice",
      name: "Invoice No.",
      selector: (row) => row?.bill_invoice,
      sortable: true,
    },
    {
      id: "p_id",
      name: "Party",
      selector: (row) =>
        parties?.data?.find(({ p_id }) => p_id === row?.p_id)?.p_name,
      sortable: true,
    },
    {
      id: "ser_name",
      name: "Service",
      selector: (row) => row.ser_name,
      sortable: true,
    },
    {
      id: "size_id",
      name: "Size",
      selector: (row) => {
        const size = sizes?.data?.find(
          ({ size_id }) => size_id === row?.size_id
        );
        return size
          ? `${Number(size?.size_from)?.toFixed(2)} - ${Number(
              size?.size_to
            )?.toFixed(2)}`
          : "Fixed";
      },
      sortable: true,
    },
    {
      id: "bill_pcs",
      name: "Pcs",
      selector: (row) => row.bill_pcs,
      sortable: true,
    },
    {
      id: "bill_date",
      name: "Date",
      selector: (row) => moment(row?.bill_date).format("DD/MM/YYYY"),
      width: "150px",
      sortable: true,
    },
    {
      id: "bill_cts",
      name: "Weight",
      selector: (row) => row.bill_cts.toFixed(2),
      sortable: true,
    },
    {
      id: "bill_rate",
      name: "Rate",
      selector: (row) => row?.bill_rate,
      sortable: true,
    },
    {
      id: "bill_amount",
      name: "Amount",
      selector: (row) => row?.bill_amount?.toFixed(2),
      sortable: true,
    },
    {
      id: "bill_total",
      name: "Total",
      selector: (row) => row?.bill_total?.toFixed(2),
      sortable: true,
    },
  ];
  const columns = [
    {
      id: "id",
      name: "ID",
      value: (row) => row?.bill_id,
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "bill_invoice",
      name: "Invoice No.",
      selector: (row) => row?.bill_invoice,
      sortable: true,
    },
    {
      id: "p_id",
      name: "Customer",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_name;
      },
      sortable: true,
    },
    {
      id: "p_org_gst",
      name: "GST No.",
      selector: (row) => {
        return row?.p_org_gst || "-";
      },
    },
    {
      id: "p_org_state",
      name: "State",
      selector: (row) => row?.p_org_state,
      sortable: true,
    },
    {
      id: "p_org_pincode",
      name: "ZIP Code",
      selector: (row) => row?.p_org_pincode || "-",
      sortable: true,
    },
    {
      id: "bill_date",
      name: "Date",
      selector: (row) => moment(row?.bill_date).format("DD/MM/YYYY"),
      width: "150px",
      sortable: true,
    },
    {
      id: "sub_count",
      name: "Pcs",
      selector: (row) => row?.bill_pcs,
      width: "150px",
      sortable: true,
    },
    {
      id: "sub_weight",
      name: "Weight",
      selector: (row) => row?.bill_cts,
      width: "150px",
      sortable: true,
    },
    {
      id: "bill_amount",
      name: "Gross Amount($)",
      selector: (row) => Number(row?.bill_amount)?.toFixed(2),
      sortable: true,
      type: "number",
    },
    {
      id: "bill_total",
      name: "Gross Total",
      selector: (row) => Number(row.bill_total)?.toFixed(2),
      sortable: true,
      type: "number",
    },
    {
      id: "bill_cgst",
      name: "CGST",
      selector: (row) => {
        const startsWith24 = row?.p_org_gst?.startsWith(gst_number);
        return startsWith24 ? Number(row?.bill_cgst)?.toFixed(2) : "-";
      },
      sortable: true,
      type: "number",
    },
    {
      id: "bill_sgst",
      name: "SGST",
      selector: (row) => {
        const startsWith24 = row?.p_org_gst?.startsWith(gst_number);
        return startsWith24 ? Number(row?.bill_sgst)?.toFixed(2) : "-";
      },
      sortable: true,
      type: "number",
    },
    {
      id: "bill_igst",
      name: "IGST",
      selector: (row) => {
        const startsWith24 = row?.p_org_gst?.startsWith(gst_number);
        return !startsWith24 ? Number(row?.bill_igst)?.toFixed(2) : "-";
      },
      sortable: true,
      type: "number",
    },
    {
      id: "bill_net_amount",
      name: "Net Amount",
      selector: (row) => Number(row?.bill_net_amount)?.toFixed(2),
      sortable: true,
      type: "number",
    },
    {
      id: "actions",
      name: "Action",
      width: "200px",
      value: () => "",
      selector: (row) => {
        return (
          <BTBox display="flex" flexDirection={"row"} gap={1}>
            {/* <BTButton
              size="small"
              color="dark"
              loadingPosition="start"
              variant="gradient"
              disabled={userdata?.u_type !== 1 && row?.bill_status !== 1}
              onClick={async () => {
                const response = await getSubillData(row?.bill_id);
                if (response) {
                  setOpen({
                    billsData: {
                      ...row,
                      sub_billing_lines: response,
                    },
                  });
                } else {
                  addNotification({
                    message:
                      response?.message?.message || "Something went wrong",
                    type: "error",
                    color: "error",
                    icon: <Error fontSize="small" color="white" />,
                  });
                }
              }}
            >
              {row?.bill_status === 1 ? "Confirm bill" : "Update bill"}
            </BTButton> */}
            <Tooltip title="download bill">
              <PictureAsPdf
                sx={{
                  cursor: "pointer",
                  fontSize: "20px",
                }}
                onClick={() => handleDownloadPDF(row)}
                // onClick={async () => {
                //   // const response = await getSubillData(row?.bill_id);
                //   // if (response) {
                //   //   const billsData = {
                //   //     ...row,
                //   //     sub_billing_lines: response,
                //   //   };
                //   //   handleDownloadPDF(billsData);
                //   // } else {
                //   //   addNotification({
                //   //     message:
                //   //       response?.message?.message || "Something went wrong",
                //   //     type: "error",
                //   //     color: "error",
                //   //     icon: <Error fontSize="small" color="white" />,
                //   //   });
                //   // }
                // }}
              />
            </Tooltip>
            <Tooltip title="submissions">
              <TrackChanges
                sx={{
                  cursor: "pointer",
                  color: "secondary.main",
                  fontSize: "18px",
                }}
                onClick={() => openSubmissions(row?.bill_id)}
              />
            </Tooltip>
            {row?.bill_status === 1 && (
              <Tooltip title={"Edit"}>
                <Edit
                  sx={{
                    cursor: "pointer",
                    color: "secondary.main",
                    fontSize: "18px",
                  }}
                  onClick={() => handleEdit(row)}
                />
              </Tooltip>
            )}
            {row?.bill_status === 1 && (
              <Tooltip title="delete">
                <Delete
                  sx={{
                    cursor: "pointer",
                    color: "error.main",
                    fontSize: "18px",
                  }}
                  onClick={async () => {
                    deleteBill(row);
                    // const response = await getSubillData(row?.bill_id);
                    // if (response) {
                    //   const bill_data = {
                    //     ...row,
                    //     sub_billing_lines: response,
                    //   };
                    //   deleteBill(bill_data);
                    // } else {
                    //   addNotification({
                    //     message:
                    //       response?.message?.message || "Something went wrong",
                    //     type: "error",
                    //     color: "error",
                    //     icon: <Error fontSize="small" color="white" />,
                    //   });
                    // }
                  }}
                />
              </Tooltip>
            )}
          </BTBox>
        );
      },
    },
  ];
  const renderData = bill?.data?.filter(
    ({ bill_type }) => bill_type === search?.type
  );

  return (
    <DashboardLayout>
      <CardHeader
        search={search}
        setSearch={setSearch}
        parties={parties?.data}
        setLoading={setLoading}
        tableType={tableType}
        setTableType={setTableType}
        clearState={clearState}
      />
      <BTBox mt={4}>
        <EnhancedTable
          columns={tableType ? expandColumns : columns}
          loading={loading}
          tableHeader={true}
          rows={renderData?.slice(startIndex, endIndex)}
          title="Billing"
          defaultSort="carbs"
          pagination={true}
          expandComponent={
            <ExpandComponent
              expandColumns={expandColumns}
              subRefresh={subRefresh}
              bill={bill?.data}
            />
          }
          expandRow={tableType ? false : true}
          checkBoxSelected={true}
          fetchData={{
            fnc: fetchData,
            params: {
              api: "get_bills",
              searchParams: {
                ...search,
                page: 1,
                rowsPerPage: bill?.total,
              },
              filterCallback: null,
              name: "bill",
              key: "bill_id",
              showLoading,
              hideLoading,
              hold: false,
            },
          }}
          selectedConfiguration={{
            bgColor: "white",
            buttons: [
              <BTButton
                color={"dark"}
                variant={"gradient"}
                size="small"
                onClick={handleDownloadJson}
                fullWidth
                sx={{ width: "150px" }}
              >
                export json
              </BTButton>,
            ],
          }}
          serverSidePagination={true}
          serverSideSearch={true}
          totalRows={bill.total}
          onPageChange={({ page, rowsPerPage, searchText }) => {
            if (search?.rowsPerPage !== rowsPerPage) {
              clearState();
            }
            setSearch({
              ...search,
              page,
              rowsPerPage,
              searchText,
              last_id: bill?.pages[pageIndex]?.next_last_id,
            });
          }}
          onSearchChange={(searchText, { page, rowsPerPage }) => {
            clearState();
            setSearch((prev) => ({ ...prev, searchText, page, rowsPerPage }));
          }}
          initialPage={search?.page}
          getRowStyle={(row) => {
            if (row?.bill_status === 2) {
              return {
                backgroundColor: "#f8c1bfff",
                "&:hover": {
                  backgroundColor: "#ffffffff",
                },
              };
            }
          }}
        />
      </BTBox>
      {Boolean(open) && (
        <Addbill
          open={open}
          setOpen={setOpen}
          parties={parties?.data}
          todayRate={todayRate}
          sizes={sizes?.data}
          type={tableType}
        />
      )}
      {Boolean(showSubmissions) && (
        <Submissions
          showSubmissions={showSubmissions}
          setShowSubmissions={setShowSubmissions}
          parties={parties?.data}
          sizes={sizes?.data}
        />
      )}
    </DashboardLayout>
  );
};
export default Bill;
